module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAOCAYAAADABlfOAAAAAXNSR0IArs4c6QAAATZJREFUOE+tk+FtAjEMhW3f/S8bECU3AJ2gdANGYAPUCUo36Ah0ktINOsDFFzboAomp0eUanQ4koPkVxcmn5+cXdM7t4cLy3i9zOd+NMa5DCKF8ZoxZVFX1DgA7tNaKFhHxa4pdQsu75bm+a5pmmVL6/EW9DVBmxkuKtZahuiei57Zthy7vhR4AYA4AB2Y2WchdULVJRL4BYAMAL8ysPk63r+2M2y/by+0rNMa4IqLToFJKJoTwM6l0ys+xz+qpQnVI1totALyKyEfXdetJ6DVK8+Sttap2nlJ6rOt6dvP0s9LSRz1DxO2/QBWsH0JEnjSfasdNOS2VKtQYY4io61Nxgl8d/jG0T4XGSiOm6w967jeVCSinP/r3sz5iDxmq0Ti7mHmoa4wQMXjvd+MHzrmViCyIaH8EJBDgTABuVwwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home10@2x.png
// module id = czFG
// module chunks = 1